import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import * as _ from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q16',
  templateUrl: './r-q16.component.html',
  styleUrls: ['./r-q16.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ16Component implements OnInit {
  home_use = [];
  @Input() data: any;
  isDisable;
  showTip = false;
  question;
  questions;
  userResponses = [];
  index;
  questionObj;
  messagetype;
  hgHomeuse = {
    use1: false,
    use2: false,
    use3: false,
    use4: false
  };
  deviceWidth;
  user_bot;
  time = 0;
  use1_id;
  use2_id;
  use3_id;
  use4_id;
  showTyping = false;
  timer;
  typingTimer;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.use1_id = document.getElementById('use1_mob');
      this.use2_id = document.getElementById('use2_mob');
      this.use3_id = document.getElementById('use3_mob');
      this.use4_id = document.getElementById('use4_mob');
    } else {
      this.use1_id = document.getElementById('use1');
      this.use2_id = document.getElementById('use2');
      this.use3_id = document.getElementById('use3');
      this.use4_id = document.getElementById('use4');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        if (this.residentialService.service === 'New Service') {
          this.question = this.questions[i].res_question_ns;
        } else {
          this.question = this.questions[i].res_question;
        }
        this.questionObj = this.questions[i];
        // If the flow is from renewal -> show 'renewal_question' text
        if (this.residentialService.questionFlowType === 'renewal') {
          this.question = this.questions[i].renewal_question;
        }
        this.index = i;
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.home_use = obj.fieldValue;
        if (!_.isEmpty(this.home_use)) {
          for (let j = 0; j < this.home_use.length; j++) {
            if (this.home_use[j] === 'I live there (primary residence)') {
              this.hgHomeuse.use1 = true;
              this.use1_id.parentElement.classList.add('active-select');
            } else if (this.home_use[j] === 'Secondary / vacation home') {
              this.hgHomeuse.use2 = true;
              this.use2_id.parentElement.classList.add('active-select');
            } else if (this.home_use[j] === 'Work from home / home-based business') {
              this.hgHomeuse.use3 = true;
              this.showTip = true;
              this.use3_id.parentElement.classList.add('active-select');
            } else if (this.home_use[j] === 'Airbnb or occassional rental') {
              this.hgHomeuse.use4 = true;
              this.use4_id.parentElement.classList.add('active-select');
            }
          }
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.showTyping = true;
            setTimeout(() => {
              this.showTyping = false;
              this.next();
            }, this.time);
          }
        }
      }
    }
    this.messagetype = this.residentialService.messervicetype;
  }

  getHome_use(home_use_option, use) {
    if (this.deviceWidth < 768) {
      this.residentialService.unSelectService({'currentId': this.data});
    }
    // console.log.log(this.hgHomeuse);
    if (home_use_option === 'I live there (primary residence)' && use === true) {
      this.home_use.push(home_use_option);
      this.showTip = false;
      this.use1_id.parentElement.classList.add('active-select');
    } else if (home_use_option === 'I live there (primary residence)' && use === false) {
      if (!_.isEmpty(this.home_use)) {
        const index = this.home_use.indexOf(home_use_option);
        this.home_use.splice(index, 1);
        this.use1_id.parentElement.classList.remove('active-select');
      }
    } else if (home_use_option === 'Secondary / vacation home' && use === true) {
      this.home_use.push(home_use_option);
      this.showTip = false;
      this.use2_id.parentElement.classList.add('active-select');
    } else if (home_use_option === 'Secondary / vacation home' && use === false) {
      if (!_.isEmpty(this.home_use)) {
        const index = this.home_use.indexOf(home_use_option);
        this.home_use.splice(index, 1);
        this.use2_id.parentElement.classList.remove('active-select');
      }
    } else if (home_use_option === 'Work from home / home-based business' && use === true) {
      this.home_use.push(home_use_option);
      this.showTip = true;
      this.use3_id.parentElement.classList.add('active-select');
    } else if (home_use_option === 'Work from home / home-based business' && use === false) {
      if (!_.isEmpty(this.home_use)) {
        const index = this.home_use.indexOf(home_use_option);
        this.home_use.splice(index, 1);
        this.use3_id.parentElement.classList.remove('active-select');
      }
    } else if (home_use_option === 'Airbnb or occassional rental' && use === true) {
      this.home_use.push(home_use_option);
      this.showTip = false;
      this.use4_id.parentElement.classList.add('active-select');
    } else if (home_use_option === 'Airbnb or occassional rental' && use === false) {
      if (!_.isEmpty(this.home_use)) {
        const index = this.home_use.indexOf(home_use_option);
        this.home_use.splice(index, 1);
        this.use4_id.parentElement.classList.remove('active-select');
      }
    }
    if (_.isEmpty(this.home_use)) {
      this.user_bot = false;
      this.showTip = false;
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
    } else {
     if (_.contains(this.home_use, 'Work from home / home-based business')) {
        this.showTip = true;
      } else {
        this.showTip = false;
      }
      this.user_bot = true;
      this.time = 3000;
      // // console.log.log(this.time);
      this.goNext();
    }
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.showTyping = false;
      }
      this.typingTimer = setTimeout(() => {
        this.showTyping = true;
      }, 250);
      this.timer = setTimeout(() => {
        // // console.log.log(this.time);
        this.showTyping = false;
        this.next();
      }, this.time);
    }
  }

  next() {
    if (_.isEmpty(this.home_use)) {
      // console.log.log(this.home_use);
      // alert('Select atleast one home_use.');
      this.residentialService.unSelectService({'currentId': this.data});
    } else {
      this.save();
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'res_question_id': this.data, 'fieldName': 'home_use', 'fieldValue': this.home_use
    };
    this.residentialService.updateResponses(Obj);
  }
}
